<template>
  <div>
    <img :src="src1" alt="" />
    <img :src="src2" alt="" />
  </div>
</template>
<script>
import axios from "@/http/axios";
export default {
  data() {
    return {
      src1: "",
      src2: "",
    };
  },
  created() {
    let o = this.$route.query;
    sessionStorage.setItem("token", o.token);
    axios.post("/user/getKycMedia", {}).then((res) => {
        this.src1 = res.data.idFrontUrl;
        this.src2 = res.data.idBackUrl;
    });
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
